/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bot.vue?vue&type=template&id=10ece58b&scoped=true"
import script from "./bot.vue?vue&type=script&lang=js"
export * from "./bot.vue?vue&type=script&lang=js"
import style0 from "./bot.vue?vue&type=style&index=0&id=10ece58b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ece58b",
  null
  
)

export default component.exports